module.exports = __webpack_public_path__ + "img/plan-building-2.bc32639e.jpg";